<template>
    <div class="admin-preview-frame">
        <!-- Sidebar -->
        <div class="admin-sidebar" :style="{ background: colors.sidebar_navbar || '#022c22' }">
            <div class="admin-sidebar__logo" :style="{ color: colors.text_navbar || '#ffffff' }">
                <div class="logo-circle"></div>
                <span class="logo-text">CORPORATE</span>
            </div>
            
            <div class="admin-sidebar__menu">
                 <div class="admin-sidebar__item active" :style="{ borderLeft: '3px solid', borderColor: colors.text_navbar || '#ffffff', color: colors.text_navbar || '#ffffff' }">
                    <i class="fas fa-chart-line"></i> Dashboard
                 </div>
                 <div class="admin-sidebar__item" :style="{ color: colors.text_navbar || '#ffffff' }"><i class="fas fa-building"></i> Branch</div>
                 <div class="admin-sidebar__item" :style="{ color: colors.text_navbar || '#ffffff' }"><i class="fas fa-users"></i> Member</div>
                 <div class="admin-sidebar__item" :style="{ color: colors.text_navbar || '#ffffff' }"><i class="fas fa-cog"></i> Settings</div>
            </div>

            <div class="admin-sidebar__bottom" :style="{ background: colors.bottom_navbar || '#064e3b', color: colors.text_navbar || '#ffffff' }">
                <div class="admin-user-name">Admin User</div>
                <div class="admin-user-action">Logout</div>
            </div>
        </div>

        <!-- Main Content -->
        <div class="admin-main">
            <!-- Topbar -->
            <div class="admin-topbar" :style="{ background: colors.top_navbar || '#f8fafc', color: colors.text_navbar || '#ffffff' }">
                 <div class="admin-topbar-title">Dashboard ></div>
                 <div class="admin-topbar-text">Switch to branch / merchant for profile data.</div>
            </div>

            <div class="admin-content">
                <div class="admin-grid">
                    <!-- Cards using Primary Button color (like in the user's screenshot) -->
                    <div class="admin-card" :style="{ background: colors.primary_button || '#10b981', color: colors.text_button || '#ffffff' }">
                        <div class="admin-card-title">Today Transaction Value</div>
                        <div class="admin-card-value">
                            <i class="fas fa-shopping-cart" style="font-size: 24px; opacity: 0.8;"></i>
                            <span>IDR 0</span>
                        </div>
                    </div>
                    <div class="admin-card" :style="{ background: colors.primary_button || '#10b981', color: colors.text_button || '#ffffff' }">
                        <div class="admin-card-title">Today Voucher Claimed</div>
                        <div class="admin-card-value">
                            <i class="fas fa-ticket-alt" style="font-size: 24px; opacity: 0.8;"></i>
                            <span>0</span>
                        </div>
                    </div>
                    <div class="admin-card" :style="{ background: colors.primary_button || '#10b981', color: colors.text_button || '#ffffff' }">
                        <div class="admin-card-title">Today New Member</div>
                        <div class="admin-card-value">
                            <i class="fas fa-user-plus" style="font-size: 24px; opacity: 0.8;"></i>
                            <span>0</span>
                        </div>
                    </div>
                    <div class="admin-card" :style="{ background: colors.primary_button || '#10b981', color: colors.text_button || '#ffffff' }">
                        <div class="admin-card-title">Today Merchant Best Performer</div>
                        <div class="admin-card-value">
                            <i class="fas fa-medal" style="font-size: 24px; opacity: 0.8;"></i>
                            <span></span>
                        </div>
                    </div>
                </div>

                <div class="admin-actions">
                    <div class="admin-table-header" style="margin-bottom: 8px;">Action Buttons</div>
                    <div class="admin-btn-row">
                        <button class="admin-btn" :style="{ background: colors.primary_button || '#10b981', color: colors.text_button || '#FFFFFF' }">
                            Primary Action
                        </button>
                        <button class="admin-btn admin-btn--outline" :style="{ borderColor: colors.primary_button || '#10b981', color: colors.primary_button || '#10b981' }">
                            Secondary Action
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OThemeAdminDesktopPreview',
    props: {
        colors: { type: Object, required: true }
    }
}
</script>

<style scoped>
.admin-preview-frame {
    display: flex;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    height: 380px;
    background: #f8fafc;
    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
    overflow: hidden;
    font-family: 'Inter', sans-serif;
}

.admin-sidebar {
    width: 130px;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    transition: background 0.3s;
}

.admin-sidebar__logo {
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    border-bottom: 1px solid rgba(255,255,255,0.1);
}

.logo-circle { 
    width: 24px; 
    height: 24px; 
    border-radius: 50%; 
    background: currentColor; 
    opacity: 0.8; 
}

.logo-text {
    font-size: 10px; 
    opacity: 0.8; 
    letter-spacing: 1px;
    font-weight: 600;
}

.admin-sidebar__menu { 
    flex: 1; 
    padding: 12px 0; 
    display: flex; 
    flex-direction: column; 
    gap: 4px; 
}

.admin-sidebar__item {
    font-size: 11px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    opacity: 0.7;
}

.admin-sidebar__item.active { 
    opacity: 1; 
    font-weight: 600; 
}

.admin-sidebar__item i {
    width: 14px;
    text-align: center;
}

.admin-sidebar__bottom {
    padding: 12px;
    transition: background 0.3s;
}

.admin-user-name {
    font-weight: 600;
    font-size: 11px;
    margin-bottom: 2px;
}

.admin-user-action {
    font-size: 9px;
    opacity: 0.7;
}

.admin-main { 
    flex: 1; 
    display: flex; 
    flex-direction: column;
    overflow: hidden;
}

.admin-topbar { 
    padding: 12px 16px; 
    border-bottom: 1px solid rgba(0,0,0,0.05);
    background: #ffffff !important; /* Topbar is usually white in this desktop view */
    color: #1e293b !important;
}

.admin-topbar-title {
    font-size: 13px; 
    font-weight: 700;
}

.admin-topbar-text {
    font-size: 11px;
    color: #64748b;
    margin-top: 4px;
}

.admin-content { 
    padding: 16px; 
    flex: 1; 
    overflow-y: auto; 
}

.admin-grid { 
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    gap: 12px; 
    margin-bottom: 20px; 
}

.admin-card { 
    padding: 12px 16px; 
    border-radius: 8px; 
    transition: background 0.3s;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.admin-card-title {
    font-size: 10px; 
    font-weight: 600;
    opacity: 0.9;
    text-align: right;
}

.admin-card-value {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 18px; 
    font-weight: 800; 
    margin-top: 12px;
}

.admin-actions {
    padding-right: 20px;
}

.admin-table-header {
    font-size: 13px; 
    font-weight: 700; 
    margin-bottom: 12px;
    color: #1e293b;
}

.admin-btn-row {
    display: flex;
    gap: 8px;
}

.admin-btn {
    flex: 1;
    padding: 8px;
    border: none;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    background: #10b981;
    color: #fff;
}

.admin-btn--outline {
    background: transparent;
    border: 1px solid #10b981;
    color: #10b981;
}
</style>
